import { BasicEvent } from "../../../planera/events/BasicEvent";
export class ArbetsorderIntressenterAddedEventMessage extends BasicEvent {
    anvandareId: number;
    arbetsorderId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderIntressenterAddedEventMessage";
}
